import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Observable, throwError, Subject } from 'rxjs';
import { catchError, tap, switchMap, finalize } from 'rxjs/operators';
import { SystemService } from 'common/services/core_services/system.service';
import { API_URL } from 'common/constants/url.constants';
import { NavigateRoutes, plexPass, plexUName, RequestType, StorageConstants } from 'common/constants/app.constant';
import { environment } from 'common/environment/environment.dev';
import { LoadingService } from 'common/services/core_services/loading.service';
import { EncryptionDecryption } from 'common/utils/encrdecr.utility';
import { RouteMessage } from 'common/models/utilitymodels/base.model';
import { ErroModel, GlobalErrorHandlerService } from 'common/services/core_services/error-handler.service';
import { AppCrashlyticsService } from 'common/services/core_services/app-crashlytics.service';

@Injectable({
    providedIn: 'root',
})
export class PlexTokenInterceptor implements HttpInterceptor {
    refreshingAccessToken: boolean = false;
    accessTokenRefreshed: Subject<any> = new Subject();

    serviceCount = 0;
    refreshTokenCount = 0;
    tokenFailed = 0;

    errModel: ErroModel = new ErroModel();

    constructor(private systemService: SystemService, private httpClient: HttpClient, private loaderService: LoadingService, private handleErroService: GlobalErrorHandlerService, private appCrashlyticsService: AppCrashlyticsService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
        this.serviceCount++;
        if (this.serviceCount === 1) {
            if (!request.url.includes(API_URL.statusCobrand) && !request.url.includes(API_URL.prostartIncreaseLikeCount) && !request.url.includes(environment.cloudErrUrl)) {
                this.loaderService.showLoader('Loading...');
            }
        }

        const endPoint = environment.platform !== 'web' ? request.url.split('/')[3] : request.url.split('/')[1];

        request;
        request = this.addAuthHeader(request, endPoint);
        this.appCrashlyticsService.addedCustomtraces('start', `${environment.envName.toUpperCase()}-${request.url}`);
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                let tokenUrl;
                if (endPoint === environment.plexAPIEndpoint || endPoint === environment.newPlexAPIEndpoint) {
                    tokenUrl = API_URL.generateToken;
                }
                if (endPoint === environment.kbhEndpoint) {
                    tokenUrl = this.systemService.getSesstionStorage(StorageConstants.isPreLoginInitiat) ? API_URL.preLoginRefreshToken : API_URL.generateRefreshToken;
                }


                if ((error.status === 401 || error.status === 0) && tokenUrl !== error.url) {
                    this.refreshTokenCount++;
                    this.refreshingAccessToken = false;
                    this.systemService.removeLocalStorage(this.getTokenFromEndpoint(endPoint));
                    // if (this.refreshTokenCount < 2) {

                    return this.refreshAccessToken(endPoint).pipe(
                        switchMap(() => {
                            request = this.addAuthHeader(request, endPoint);
                            return next.handle(request);
                        }),
                        catchError((err: Error) => {
                            return throwError(err);
                        })
                    );
                } else if (tokenUrl === error.url) {
                    this.tokenFailed++;
                    return throwError(error);
                } else {
                    this.systemService.underMaintenance = false;
                    return throwError(error);
                }
            }),
            finalize(() => {
                this.appCrashlyticsService.addedCustomtraces('end', `${environment.envName.toUpperCase()}-${request.url}`);
                this.serviceCount--;
                setTimeout(() => {
                    if (this.serviceCount === 0) {
                        this.loaderService.hideLoader();
                    }
                }, 300);
                if (this.tokenFailed === 2) {
                    this.systemService.isTransactionRouteForPopup = false;
                    this.systemService.isCoBrandLoadRouteForPopup = false;
                    if (this.systemService.deviceInfo.platform !== 'web') {
                        const routeMessage = new RouteMessage();
                        routeMessage.type = RequestType.BLANK;
                        routeMessage.transferData['hideBiomatricPopUp'] = false;
                        this.systemService.routeByUrl(NavigateRoutes.loginViaOtp, routeMessage);
                        this.systemService.showToaster('Your session timed out. Please login again to continue', 'error');
                    } else {
                        this.systemService.dismissPopup();
                        this.systemService.removeLocalStorage(StorageConstants.userProfile);
                        this.systemService.removeLocalStorage(StorageConstants.kbhAccessToken);
                        this.systemService.removeLocalStorage(StorageConstants.kbhRefreshToken);
                        this.systemService.removeSessionStorage(StorageConstants.zeroAUMValue);
                        this.systemService.removeLocalStorage(StorageConstants.isEmployeeLogin);
                        this.systemService.setLocalStorage(StorageConstants.loggedInCurrently, false);
                        const routeMsg = new RouteMessage();
                        routeMsg.type = RequestType.GET;
                        this.systemService.routeByUrl(NavigateRoutes.welcome, routeMsg);
                        this.systemService.showToaster('Your session timed out. Please login again to continue', 'error');
                    }

                    this.tokenFailed = 0;
                }
            })
        );
    }

    refreshAccessToken(endpoint: string) {
        this.refreshingAccessToken = true;
        let tokenUrl = '';
        let tokenBody;
        if (endpoint === environment.plexAPIEndpoint || endpoint === environment.newPlexAPIEndpoint) {
            tokenUrl = environment.appUrl + API_URL.generateToken;
            tokenBody = { Username: plexUName, Password: plexPass };
        }
        if (endpoint === environment.kbhEndpoint) {
            tokenUrl = this.systemService.getSesstionStorage(StorageConstants.isPreLoginInitiat) ? API_URL.preLoginRefreshToken : API_URL.generateRefreshToken;
            tokenBody = { refreshToken: this.systemService.getLocalStorage(StorageConstants.kbhRefreshToken) };
        }
        if (endpoint === environment.crmMappingEndpoint) {
            tokenUrl = API_URL.crmMappingToken;
            tokenBody = { Username: plexUName, Password: plexPass };
        }
        return this.httpClient.post(tokenUrl, tokenBody, { responseType: endpoint === environment.kbhEndpoint ? ('text' as any) : 'json' }).pipe(
            tap((data: any): any => {
                if (endpoint === environment.plexAPIEndpoint || endpoint === environment.newPlexAPIEndpoint) {
                    this.systemService.setLocalStorage(StorageConstants.plexToken, endpoint === environment.newPlexAPIEndpoint ? JSON.parse(this.decryptData(data)) : data);
                } else if (endpoint === environment.crmMappingEndpoint) {
                    this.systemService.setLocalStorage(StorageConstants.crmMappingToken, data);
                } else {
                    const decrypt = this.decryptData(data);
                    const parseData = JSON.parse(decrypt);
                    if (parseData.token !== null) {
                        this.systemService.setLocalStorage(StorageConstants.kbhAccessToken, parseData.token);
                    } else {
                        this.systemService.isTransactionRouteForPopup = false;
                        this.systemService.isCoBrandLoadRouteForPopup = false;
                        this.systemService.dismissPopup();
                        if (this.systemService.deviceInfo.platform !== 'web') {
                            if (parseData.isUserDeleted) {
                                const routeMessage = new RouteMessage();
                                routeMessage.type = RequestType.GET;
                                this.systemService.showToaster('Your session timed out. Please login again to continue', 'error');
                                this.systemService.removeLocalStorage(StorageConstants.userProfile);
                                this.systemService.routeByUrl(NavigateRoutes.welcome, routeMessage);
                            } else {
                                const routeMessage = new RouteMessage();
                                routeMessage.type = RequestType.BLANK;
                                routeMessage.transferData['hideBiomatricPopUp'] = false;
                                this.systemService.showToaster('Your session timed out. Please login again to continue', 'error');
                                this.systemService.routeByUrl(NavigateRoutes.loginViaOtp, routeMessage);
                            }
                        } else {
                            this.systemService.setLocalStorage(StorageConstants.loggedInCurrently, false);
                            this.systemService.removeLocalStorage(StorageConstants.userProfile);
                            this.systemService.removeLocalStorage(StorageConstants.kbhAccessToken);
                            this.systemService.removeLocalStorage(StorageConstants.kbhRefreshToken);
                            this.systemService.removeSessionStorage(StorageConstants.zeroAUMValue);
                            this.systemService.removeLocalStorage(StorageConstants.isEmployeeLogin);
                            this.systemService.showToaster('Your session timed out. Please login again to continue', 'error');
                            const routeMsg = new RouteMessage();
                            routeMsg.type = RequestType.GET;
                            this.systemService.routeByUrl(NavigateRoutes.welcome, routeMsg);
                        }
                        return;
                    }
                }
            })
        );
    }
    addAuthHeader(request: HttpRequest<any>, endpoint: string) {
        try {
            const token = this.systemService.getLocalStorage(this.getTokenFromEndpoint(endpoint));
            if (token) {
                if (request.url.includes(API_URL.appStateInfo) || request.url.includes(API_URL.getProfileInfo)) {
                    return request;
                }
                else if ([environment.plexAPIEndpoint, environment.kbhEndpoint, environment.crmMappingEndpoint, environment.businessDateEndpoint, environment.newPlexAPIEndpoint].includes(endpoint)) {
                    return request.clone({
                        setHeaders: {
                            Authorization: `Bearer ${token}`,
                        },
                    });
                } else {
                    return request.clone();
                }
            }
            return request;
        } catch (err) {
            this.systemService.loading.next(false);
            this.serviceCount = 0;
            if (this.systemService.deviceInfo.platform !== 'web') {
                const routeMessage = new RouteMessage();
                routeMessage.type = RequestType.GET;
                this.systemService.showToaster('Your session timed out. Please login again to continue', 'error');
                this.systemService.removeLocalStorage(StorageConstants.userProfile);
                this.systemService.routeByUrl(NavigateRoutes.welcome, routeMessage);
            } else {
                this.systemService.setLocalStorage(StorageConstants.loggedInCurrently, false);
                this.systemService.removeLocalStorage(StorageConstants.userProfile);
                this.systemService.removeLocalStorage(StorageConstants.kbhAccessToken);
                this.systemService.removeLocalStorage(StorageConstants.kbhRefreshToken);
                this.systemService.removeSessionStorage(StorageConstants.zeroAUMValue);
                this.systemService.removeLocalStorage(StorageConstants.isEmployeeLogin);
                this.systemService.showToaster('Your session timed out. Please login again to continue', 'error');
                const routeMsg = new RouteMessage();
                routeMsg.type = RequestType.GET;
                this.systemService.routeByUrl(NavigateRoutes.welcome, routeMsg);
            }
            throw err;
        }

    }

    getTokenFromEndpoint(endpoint: string) {
        let token = '';
        if (endpoint === environment.plexAPIEndpoint || endpoint === environment.newPlexAPIEndpoint) {
            token = StorageConstants.plexToken;
        }
        if (endpoint === environment.kbhEndpoint) {
            token = StorageConstants.kbhAccessToken;
        }
        if (endpoint === environment.crmMappingEndpoint) {
            token = StorageConstants.crmMappingToken;
        }
        return token;
    }

    decryptData(data: any) {
        const decrypted = new EncryptionDecryption().decrypt(data);
        return decrypted;
    }
}
